<template>
  <div class="fixed w-full bottom-4 z-50 space-y-2">
    <AppToast
      v-for="toast in toasts"
      :key="toast.id"
      :message="toast.message"
      :type="toast.type"
      :duration="toast.duration"
    />
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useToastStore } from '../../../stores/toastStore.js'
import AppToast from './AppToast.vue'

const toastStore = useToastStore()
const { toasts } = storeToRefs(toastStore)
</script>
